<template>
  <!--
      	作者：zhuchangtao
      	时间：2020-12-30
      	描述：插件中心-素材
      -->
    <div class="user">
        <div class="common-seach-wrap">
            <el-tabs v-model="activeName">
                <el-tab-pane label="建议反馈" name="suggestion">
                    <Suggestion v-if="activeName=='suggestion'"></Suggestion>
                </el-tab-pane>
                <el-tab-pane label="分类管理" name="category">
                    <Category v-if="activeName=='category'"></Category>
                </el-tab-pane>
                <!-- <el-tab-pane label="设置" name="setting">
                    <Setting v-if="activeName == 'setting'"></Setting>
                </el-tab-pane> -->
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import Suggestion from './suggestion/Index.vue';
    import Category from './category/Index.vue';
    import Setting from './setting/Setting';
    export default {
        components: {
            Suggestion,
            Category,
            Setting,
        },
        data() {
          return {
              activeName: 'suggestion',
              /*是否加载完成*/
              loading: true,
          }
        },
        created() {


        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/views/plus/suggestion/index.vue